/* PDP: gallery, accordion, quantity, sticky bar */
(function(){
  // gallery thumb -> stage
  var slides = Array.prototype.slice.call(document.querySelectorAll('.stage .slide'));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumb'));
  var dots = Array.prototype.slice.call(document.querySelectorAll('#dots span'));
  function setActive(i){
    slides.forEach(function(s){ s.classList.toggle('show', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('active', +t.dataset.i === i); });
    dots.forEach(function(d, di){ d.classList.toggle('on', di === i); });
  }
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ setActive(+t.dataset.i); }); });

  var gallery = document.getElementById('gallery');
  var stage = document.getElementById('stage');
  if (gallery && stage){
    var mq = window.matchMedia('(max-width:920px)');
    var applyMode = function(){ gallery.classList.toggle('mob', mq.matches); };
    applyMode(); mq.addEventListener('change', applyMode);
    stage.addEventListener('scroll', function(){
      if(!gallery.classList.contains('mob')) return;
      var i = Math.round(stage.scrollLeft / stage.clientWidth);
      dots.forEach(function(d, di){ d.classList.toggle('on', di === i); });
    }, { passive:true });
  }

  /* hearts (#gwish, #wishBtn) are handled by the global wishlist module via [data-wish] */

  // accordion (animate to content height; one open at a time)
  document.querySelectorAll('.acc-item').forEach(function(item){
    var head = item.querySelector('.acc-head');
    var body = item.querySelector('.acc-body');
    if (!head || !body) return;
    if (item.classList.contains('open')) body.style.maxHeight = body.scrollHeight + 'px';
    head.addEventListener('click', function(){
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.acc-item').forEach(function(o){
        o.classList.remove('open');
        var b = o.querySelector('.acc-body'); if (b) b.style.maxHeight = null;
      });
      if (!isOpen){ item.classList.add('open'); body.style.maxHeight = body.scrollHeight + 'px'; }
    });
  });

  // quantity
  var qVal = document.getElementById('qVal');
  var qInput = document.getElementById('qInput');
  var q = 1;
  function setQ(n){ q = Math.max(1, n); if(qVal) qVal.textContent = q; if(qInput) qInput.value = q; }
  var qm = document.getElementById('qMinus'), qp = document.getElementById('qPlus');
  if (qm) qm.addEventListener('click', function(){ setQ(q-1); });
  if (qp) qp.addEventListener('click', function(){ setQ(q+1); });

  // sticky add bar
  var sticky = document.getElementById('stickybar');
  var addBag = document.getElementById('addBag');
  if (sticky && addBag){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ sticky.classList.toggle('show', !e.isIntersecting); });
    }, { threshold: 0 });
    io.observe(addBag);
  }

  // lock the title to the height of its tallest shade name — the shade suffix swaps
  // in place on consolidated products, and without a reserved height the whole page
  // reflows every time a longer/shorter name wraps to a different line count
  var lockH1 = document.querySelector('.pinfo-col h1');
  var lockSpan = document.getElementById('pdpTitle');
  var lockTarget = lockSpan || (lockH1 ? lockH1.querySelector('.h1-color') : null);
  if (lockH1 && lockTarget){
    var lockNames = [];
    document.querySelectorAll('.pinfo-col .swatch').forEach(function(s){
      var n = s.getAttribute('data-val') || s.getAttribute('title') || '';
      n = n.replace(/\s*—\s*sold out\s*$/i, '').trim();
      if (n && lockNames.indexOf(n) === -1) lockNames.push(n);
    });
    if (lockNames.length > 1){
      var lockRun = function(){
        var orig = lockTarget.textContent;
        lockH1.style.minHeight = '';
        var max = 0;
        lockNames.forEach(function(n){
          lockTarget.textContent = lockSpan ? n : '— ' + n;
          var h = lockH1.offsetHeight;
          if (h > max) max = h;
        });
        lockTarget.textContent = orig;
        lockH1.style.minHeight = max + 'px';
      };
      lockRun();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(lockRun);
      var lockTimer;
      window.addEventListener('resize', function(){ clearTimeout(lockTimer); lockTimer = setTimeout(lockRun, 150); });
    }
  }

  // size comparison viz (if present)
  var viz = document.getElementById('sizeCompare');
  if (viz){
    var vizSel = document.getElementById('vizSel');
    var VIZ = { standard: viz.dataset.std || 'Standard', mini: viz.dataset.mini || 'Mini' };
    var setViz = function(s){
      viz.dataset.sel = s;
      if (vizSel) vizSel.textContent = VIZ[s];
      document.querySelectorAll('.viz-pill').forEach(function(p){ p.classList.toggle('active', p.dataset.size === s); });
    };
    document.querySelectorAll('.viz-pill').forEach(function(b){ b.addEventListener('click', function(){ setViz(b.dataset.size); }); });
    document.querySelectorAll('.viz [data-size]').forEach(function(r){ r.addEventListener('click', function(){ setViz(r.dataset.size); }); });
  }
})();

/* native Shopify variant picker (apparel etc. with real Color/Size options) */
(function(){
  var el = document.getElementById('variantData');
  if (!el) return;
  var variants;
  try { variants = JSON.parse(el.textContent); } catch(e){ return; }
  var form = document.getElementById('productForm');
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var addBag = document.getElementById('addBag');
  var priceVal = document.getElementById('priceVal');
  var stickyPrice = document.getElementById('stickyPrice');
  var priceWas = document.getElementById('priceWas');
  var stickyWas = document.getElementById('stickyWas');
  var stickyName = document.getElementById('stickyName');
  var stickySize = document.getElementById('stickySize');
  var finalSalePill = document.getElementById('finalSalePill');
  var finalSaleProp = document.getElementById('finalSaleProp');
  var bis = document.getElementById('chbis');
  var buyrow = document.querySelector('.buyrow');
  var paylater = document.querySelector('.paylater');
  var stickyAdd = document.getElementById('stickyAdd');
  var guarantee = document.querySelector('.guarantee');
  var FS = []; var fsEl = document.getElementById('finalSaleVariants');
  if (fsEl){ try { FS = JSON.parse(fsEl.textContent); } catch(e){} }
  var buttons = Array.prototype.slice.call(document.querySelectorAll('.pinfo-col [data-opt]'));
  if (!buttons.length) return;

  var optCount = 0;
  buttons.forEach(function(b){ optCount = Math.max(optCount, parseInt(b.getAttribute('data-opt'),10) + 1); });
  var selected = new Array(optCount);
  buttons.forEach(function(b){
    if (b.classList.contains('active')){
      selected[parseInt(b.getAttribute('data-opt'),10)] = b.getAttribute('data-val');
      var io2 = b.getAttribute('data-opt2');   // swatch may carry a 2nd option (e.g. set size)
      if (io2 !== null) selected[parseInt(io2,10)] = b.getAttribute('data-val2');
    }
  });
  // which option index is the colour swatch? (so the sticky bar shows colour as the name, sizes after the ·)
  var colorIdx = -1;
  buttons.forEach(function(b){ if (b.classList.contains('swatch')) colorIdx = parseInt(b.getAttribute('data-opt'),10); });

  function money(cents){ return '$' + (cents/100).toFixed(2); }
  function findVariant(){
    return variants.find(function(v){
      var opts = v.options || [];
      if (opts.length !== selected.length) return false;
      for (var i=0;i<selected.length;i++){ if (opts[i] !== selected[i]) return false; }
      return true;
    });
  }
  function update(){
    var v = findVariant();
    if (!v){ if (addBag){ addBag.disabled = true; addBag.textContent = 'Unavailable'; } return; }
    if (idInput) idInput.value = v.id;
    // FS list = metafield-flagged variants + discounted variants on sale-tagged products
    // (bundles carry compare-at as value anchoring, so don't infer from price alone)
    var isFS = FS.indexOf(v.id) !== -1;
    if (finalSalePill) finalSalePill.style.display = isFS ? '' : 'none';
    if (finalSaleProp) finalSaleProp.disabled = !isFS;
    // hide First Hijab Guarantee on final-sale variants
    if (guarantee) guarantee.hidden = isFS;
    var m = money(v.price);
    if (priceVal) priceVal.textContent = m;
    if (stickyPrice) stickyPrice.textContent = m;
    // sticky bar reflects the selected variant: colour as the name, the remaining option(s) after the ·
    if (stickyName && colorIdx >= 0 && selected[colorIdx]) stickyName.textContent = selected[colorIdx];
    if (stickySize){
      var sizeParts = [];
      for (var si = 0; si < selected.length; si++){ if (si !== colorIdx && selected[si]) sizeParts.push(selected[si]); }
      if (sizeParts.length) stickySize.textContent = sizeParts.join(' · ');
    }
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    [priceWas, stickyWas].forEach(function(w){
      if (!w) return;
      if (onSale){ w.textContent = money(v.compare_at_price); w.hidden = false; }
      else { w.textContent = ''; w.hidden = true; }
    });
    if (addBag){
      if (v.available){
        addBag.disabled = false; addBag.style.opacity = ''; addBag.style.cursor = '';
        addBag.innerHTML = 'Add to bag <span class="pp">— ' + m + '</span>';
      } else { addBag.disabled = true; addBag.textContent = 'Sold out'; }
    }
    if (stickyAdd) stickyAdd.textContent = v.available ? 'Add to bag' : 'Sold out';
    if (paylater) paylater.innerHTML = v.available ? 'In stock · ready to ship in <b>1 business day</b>' : 'Currently sold out'; // keep in sync with the .paylater line in main-product.liquid
    // sold out: swap the Add to bag button for the back-in-stock module
    if (buyrow) buyrow.hidden = !v.available;
    if (bis){
      bis.hidden = v.available;
      if (window.CH_BIS){
        var sw = document.querySelector('.pinfo-col .swatch[data-opt].active');
        var setParts = [];
        for (var si = 0; si < selected.length; si++){ if (si !== colorIdx && selected[si]) setParts.push(selected[si]); }
        var setLabel = setParts.join(' · ');
        if (setLabel === 'One Size') setLabel = '';
        window.CH_BIS.update({
          shade: (colorIdx >= 0 && selected[colorIdx]) ? selected[colorIdx] : v.title,
          set: setLabel,
          hex: sw ? (sw.style.backgroundColor || sw.style.background) : '',
          variantId: v.id
        });
      }
    }
  }
  buttons.forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var oi = parseInt(btn.getAttribute('data-opt'),10);
      selected[oi] = btn.getAttribute('data-val');
      var io2 = btn.getAttribute('data-opt2');   // swatch carries a 2nd option (e.g. set size)
      if (io2 !== null) selected[parseInt(io2,10)] = btn.getAttribute('data-val2');
      document.querySelectorAll('[data-opt="'+oi+'"]').forEach(function(b){ b.classList.toggle('active', b === btn); });
      var wrap = btn.closest('.opt'); var valEl = wrap ? wrap.querySelector('[data-opt-val]') : null;
      if (valEl) valEl.textContent = btn.getAttribute('data-val');
      update();
    });
  });
  update();
})();

/* show only the selected colour + size images in the gallery (native-variant products) */
(function(){
  var colorSwatches = Array.prototype.slice.call(document.querySelectorAll('.pinfo-col .swatch[data-opt]'));
  if (!colorSwatches.length) return;
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbs .thumb'));
  var slides = Array.prototype.slice.call(document.querySelectorAll('.stage .slide'));
  var dots   = Array.prototype.slice.call(document.querySelectorAll('#dots span'));
  var optButtons = Array.prototype.slice.call(document.querySelectorAll('.pinfo-col [data-opt]'));

  function attr(i, name){ var s = slides[i]; return s ? (s.getAttribute(name) || '') : ''; }
  function activeVal(sel){ var a = document.querySelector(sel); return a ? (a.getAttribute('data-val') || '').toLowerCase() : ''; }
  function activeSize(){
    var btns = document.querySelectorAll('.pinfo-col [data-opt].active');
    for (var i=0;i<btns.length;i++){ if (!btns[i].classList.contains('swatch')) return (btns[i].getAttribute('data-val') || '').toLowerCase(); }
    return '';
  }
  function matches(i, color, size){
    var c = attr(i, 'data-colors');
    var s = attr(i, 'data-size');
    var colorOK = (c === '') || c.split(',').indexOf(color) !== -1;
    var sizeOK  = (s === '' || size === '') || s === size;  // untagged or no size selected => show
    return colorOK && sizeOK;
  }
  function applyFilter(){
    var color = activeVal('.pinfo-col .swatch[data-opt].active');
    var size  = activeSize();
    // consolidated PDP: update the colour-specific H1 + lede from the active swatch
    var aSw = document.querySelector('.pinfo-col .swatch[data-opt].active');
    if (aSw){
      var tEl = document.getElementById('pdpTitle'); if (tEl) tEl.textContent = aSw.getAttribute('data-val');
      var note = aSw.getAttribute('data-note'); var lEl = document.getElementById('colorLede');
      if (lEl && note) lEl.textContent = note;
    }
    // if this colour has no photos for the selected size, fall back to colour-only
    var any = slides.some(function(s, i){ return matches(i, color, size); });
    if (!any) size = '';
    var matched = [];
    slides.forEach(function(s, i){ if (matches(i, color, size)) matched.push(i); });
    var first = matched.length ? matched[0] : 0;
    // lower "The details" image follows the selected variant (use its 2nd shot if available)
    var fEl = document.getElementById('fabricImg');
    if (fEl && matched.length){ var fi = matched.length > 1 ? matched[1] : matched[0]; var fsrc = slides[fi] && slides[fi].getAttribute('src'); if (fsrc) fEl.setAttribute('src', fsrc); }
    thumbs.forEach(function(t){ var i = +t.dataset.i; t.style.display = matches(i, color, size) ? '' : 'none'; t.classList.toggle('active', i === first); });
    dots.forEach(function(d, i){ d.style.display = matches(i, color, size) ? '' : 'none'; d.classList.toggle('on', i === first); });
    // hide non-matching slides outright (mobile is a swipe carousel that ignores .show), keep .show for desktop fade
    slides.forEach(function(s){ var i = +s.dataset.i; var m = matches(i, color, size); s.style.display = m ? '' : 'none'; s.classList.toggle('show', i === first); });
    // mobile: snap the swipe carousel back to the first image of the selected colour/size
    var stageEl = document.getElementById('stage');
    if (stageEl) stageEl.scrollLeft = 0;
  }

  // re-filter after any colour/size option click (defer so the picker's .active toggle lands first)
  optButtons.forEach(function(btn){ btn.addEventListener('click', function(){ setTimeout(applyFilter, 0); }); });
  applyFilter();
})();

/* consolidated PDP: reflect per-colour size availability on the Standard/Mini buttons */
(function(){
  var el = document.getElementById('variantData'); if (!el) return;
  var variants; try { variants = JSON.parse(el.textContent); } catch(e){ return; }
  var swatches = Array.prototype.slice.call(document.querySelectorAll('.pinfo-col .swatch[data-opt]'));
  var sizeBtns = Array.prototype.slice.call(document.querySelectorAll('.pinfo-col .sizes .sizebtn[data-opt]'));
  if (!swatches.length || !sizeBtns.length) return;
  var colorOi = parseInt(swatches[0].getAttribute('data-opt'), 10);
  var sizeOi  = parseInt(sizeBtns[0].getAttribute('data-opt'), 10);
  function variantFor(color, size){ return variants.find(function(v){ return v.options[colorOi] === color && v.options[sizeOi] === size; }); }
  function refresh(){
    var aSw = document.querySelector('.pinfo-col .swatch[data-opt].active');
    var color = aSw ? aSw.getAttribute('data-val') : '';
    var activeOk = false, firstOk = null;
    sizeBtns.forEach(function(b){
      var v = variantFor(color, b.getAttribute('data-val'));
      b.classList.toggle('disabled', !v);
      if (v) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled','true');
      var pr = b.querySelector('.pr');
      if (pr) pr.textContent = v ? ('$' + (v.price/100).toFixed(2)) : 'Unavailable';
      if (v && !firstOk) firstOk = b;
      if (v && b.classList.contains('active')) activeOk = true;
    });
    if (!activeOk && firstOk && !firstOk.classList.contains('active')) firstOk.click();
  }
  swatches.forEach(function(sw){ sw.addEventListener('click', function(){ setTimeout(refresh, 0); }); });
  refresh();
})();
